import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

// 将APP基本配置到原型链中
// 请求接口路径
Vue.prototype.api = window.baseUrl + '/envmonitor/DipoJson.cgi';
// 嵌入页面路径
Vue.prototype.apiUrl = window.baseUrl + '/envmonitor/DipoView.cgi';
// LOGO/中心主图路径
Vue.prototype.logoUrl = window.baseUrl;

// 引入QS
import qs from 'qs'
Vue.prototype.QS = qs

// 引入JQ
import $ from 'jquery'
Vue.prototype.$ = $

// 导入AXIOS
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios;

// 引入百度地图 API
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, { ak: '0dp494QDneEAOtEmKIeEB4Q9M8bVwfPl' })

// 配置POST请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
// axios.defaults.baseURL = 'http://www.gzqingyuan.top/envmonitor/DipoJson.cgi';

//发起请求之前处理
axios.interceptors.request.use(config => {
  if (config.method == 'post' && config.data.constructor !== FormData) {
    let paramsString = '';
    //post请求参数序列化，转成一个字符串
    for (let key in config.data) {
      paramsString += key + '=' + config.data[key] + '&'
    }
    config.data = paramsString.slice(0, -1);
  }
  return config;
})

// 引入Element组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 登录超时
Vue.prototype.loginTimeout = function () {
  this.$prompt("请输入密码", "登录超时，请重新登陆", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    inputType: "password",
    inputPattern: /^.+$/,
    inputErrorMessage: "密码不能为空",
  })
    .then(({ value }) => {
      let loginID = localStorage.getItem("loginID");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DoLogin",
          loginID,
          loginPD: value,
        },
      })
        .then((res) => {
          // 登录成功
          if (res.data._STATUS == "0") {
            this.$message({
              type: "success",
              message: "登录成功",
            });
            //   存储loginToken
            let loginToken = res.data.loginToken;
            localStorage.setItem("loginToken", loginToken);

            location.reload();
          } else {
            this.$message({
              message: res.data._ERROR,
              type: "warning",
            });

            let _this = this;
            setTimeout(() => {
              _this.loginTimeout();
            }, 800)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    })
    .catch(() => {
      this.$message({
        type: "info",
        message: "取消输入",
      });
      // 清楚本地存储
      window.localStorage.removeItem("loginToken");
      this.$router.push("/login");
      // location.reload();
    });
}

// 按需引入
import {
  Button,
  Input, Checkbox,
  Pagination,
  Popover,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Cascader,
  Select,
  Row,
  Col,
  Empty,
  Upload,
  Divider,
  Form,
  FormItem,
  TimePicker,
  Switch,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Collapse,
  CollapseItem,
} from 'element-ui';
Vue.use(Button)
  .use(Input)
  .use(Checkbox)
  .use(Pagination)
  .use(Popover)
  .use(Drawer)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Tabs)
  .use(TabPane)
  .use(Cascader)
  .use(Select)
  .use(Row)
  .use(Col)
  .use(Empty)
  .use(Upload)
  .use(Divider)
  .use(Form)
  .use(FormItem)
  .use(TimePicker)
  .use(Switch)
  .use(CheckboxGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Collapse)
  .use(CollapseItem)

// 引入echarts
Vue.prototype.echarts = require('echarts');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
